<template>
	<div style="position: relative; width: 100%; height: 100%;">
		<div id="d005" class="diagram" style="padding-bottom: 3rem;"></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot bcPrimary"></span> {{ 'Tillgångar' | T }}
			<span class="dot bcTertiary"></span> {{ 'Skulder' | T}}
			<span class="dot bcLightGrey"></span> {{ 'Obeskattade reserver' | T }}
			<span class="dot result"></span> {{ 'Eget kapital' | T }}
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D005",
	components: {},
	props: {
		balance: Object,
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d005",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [
				...Array(3).fill(colors.Primary),
				...Array(3).fill(colors.Tertiary),
				colors.LightGrey,
				colors.Green,
				colors.Red,
			],

			xAxis: {
				categories: this.balance.sheets
					.map((s) => s.DATE_TO.substr(0, 4))
					.reverse(),
				labels: {
					style: { fontSize: "1rem", color: colors.Black },
				},
			},

			yAxis: {
				opposite: true,

				allowDecimals: false,
				title: {
					text: "",
				},
				labels: {
					formatter() {
						return Vue.options.filters.KR(this.value);
					},
					style: { fontSize: "1rem", color: colors.DarkGrey },
				},
				tickPixelInterval: 150,
				plotLines: [{
					color: colors.Black,
					width: 2,
					value: 0,
					zIndex: 2,
				}],
				gridLineColor: colors.LightGrey,
			},

			tooltip: {
				formatter: function() {
					return (
						"<b>" +
						this.x +
						"</b><br/>" +
						this.series.name +
						": " +
						Vue.options.filters.TKR(this.y) +
						"<br/>"
					);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					stacking: "normal",
					borderColor: colors.DarkGrey,
				},
			},

			series: [
				{
					name: Vue.prototype.$t("Tecknat men ej inbetalt kapital"),
					data: this.balance.sheets.map((s) => s.A).reverse(),
					stack: "tillgang",
				},
				{
					name: Vue.prototype.$t("Omsättningstillgångar"),
					data: this.balance.sheets.map((s) => s.K).reverse(),
					stack: "tillgang",
				},
				{
					name: Vue.prototype.$t("Anläggningstillgångar"),
					data: this.balance.sheets.map((s) => s.E).reverse(),
					stack: "tillgang",
				},
				{
					name: Vue.prototype.$t("Kortfristiga skulder"),
					data: this.balance.sheets.map((s) => s.Q).reverse(),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Långfristiga skulder"),
					data: this.balance.sheets.map((s) => s.P).reverse(),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Avsättningar"),
					data: this.balance.sheets.map((s) => s.O).reverse(),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Obeskattade reserver"),
					data: this.balance.sheets.map((s) => s.N).reverse(),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Eget kapital"),
					data: this.balance.sheets.map((s) => (s.M > 0 ? s.M : 0)).reverse(),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Negativt eget kapital"),
					data: this.balance.sheets.map((s) => (s.M < 0 ? s.M : 0)).reverse(),
					stack: "tillgang",
				},
			],
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
